import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js'

/**
 * setupChartJS — registers Chart.js scales and plugins once at app boot.
 * Called from src/main.ts before app.mount().
 * All chart components (LiveChart, PositionStackedChart) rely on this registration.
 */
export function setupChartJS(): void {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
        Filler,
    )
}
